import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  title: string;
  tag?: 'h1' | 'h2';
  primary?: boolean;
  white?: boolean;
  className?: {
    container?: string;
    title?: string;
  };
}

export const Heading = ({ props }: { props: HeadingProps }) => {
  const Tag = props.tag ?? 'h2';
  return (
    <div className={cn('w-full', props.className?.container)}>
      <Tag
        className={cn(
          'font-bold uppercase',
          'text-4xl sm:text-5xl',
          props.primary && 'text-primary',
          props.white && 'text-white',
          !props.primary && !props.white && 'text-foreground',
        )}
      >
        {props.title}
      </Tag>
    </div>
  );
};
